import apiClient from "../../axios/apiClient";

export const getCallLogsList =
  (token, limit = 10, page = 1, search = "", sort = "desc") =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_CALL_LOGSLIST_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Call-Logs`,
        {
          params: {
            limit: limit,
            page: page,
            search: search,
            sort: sort,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //console.log('response.data?.data',response.data?.data);
      dispatch({
        type: "GET_CALL_LOGSLIST_FULFILLED",
        payload: response.data?.data,
        count: response.data?.count,
        permissions: response.data?.permissions,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: "GET_CALL_LOGSLIST_REJECTED",
        payload: error.response,
      });
    }
  };


  export const saveCallLogsData = (token, data) => async (dispatch) => {
    try {
      console.log('token, data', token, data);
      dispatch({ type: "ADD_CALL_LOGS_PENDING" });
  
      const response = await apiClient.post(
        `/api/admin/v1/Add-Call-Logs`,
        data, // Data payload should be the second argument
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({ type: "ADD_CALL_LOGS_FULFILLED", payload: response.data });
    } catch (error) {
      //console.log(error.response.data);
      dispatch({ type: "ADD_CALL_LOGS_REJECTED", payload: error.response });
    }
  };
  

  export const getCallLogsListById =(token,id) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_CALL_LOGSLISTBYID_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Call-Logs/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //console.log('response.data?.data',response.data?.data);
      dispatch({
        type: "GET_CALL_LOGSLISTBYID_FULFILLED",
        payload: response.data?.data,
        cityCount: response.data?.count,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: "GET_CALL_LOGSLISTBYID_REJECTED",
        payload: error.response,
      });
    }
  };


export const updateCallLogsData = (token, data, id) => async (dispatch) => {
  try {
    console.log('token, data', token, data);
    dispatch({ type: "UPDATE_CALL_LOGS_PENDING" });

    const response = await apiClient.post(
      `/api/admin/v1/Update-Call-Logs/${id}`, // Endpoint URL with CallLogs ID
      data, // Data payload
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "UPDATE_CALL_LOGS_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "UPDATE_CALL_LOGS_REJECTED", payload: error.response });
  }
};


export const updateCallLogsStatusData = (token, id, status) => async (dispatch) => {
  try {
    //console.log('token, data', token, data);
    dispatch({ type: "UPDATE_CALL_LOGS_STATUS_PENDING" });
    const data={
      "status":status
    }
    const response = await apiClient.post(
      `/api/admin/v1/Update-CallLogs-Status/${id}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "UPDATE_CALL_LOGS_STATUS_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "UPDATE_CALL_LOGS_STATUS_REJECTED", payload: error.response });
  }
};


export const deleteCallLogsData = (token, id) => async (dispatch) => {
  try {
    console.log('token, id', token, id);
    dispatch({ type: "DELETE_CALL_LOGS_PENDING" });

    const response = await apiClient.delete(
      `/api/admin/v1/Delete-Call-Logs/${id}`, // Endpoint URL with CallLogs ID
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "DELETE_CALL_LOGS_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "DELETE_CALL_LOGS_REJECTED", payload: error.response });
  }
};